const loadTranslations = async (language) => {
      try {
            const [
                  // common
                  common,
                  // login
                  login,
                  forgotPassword,
                  checkEmail,
                  logout,
                  // sidebar & topbar
                  sidebar,
                  topbar,
                  // notifications
                  notifications,
                  // Dashboard
                  cardsSections,
                  statisticsSection,
                  // rides
                  rides,
                  addNewRide,
                  viewRide,
                  cancelRide,
                  cancelSharedRide,
                  endSharedRide,
                  endRide,
                  assignRide,
                  addNewCustomer,
                  assignDriver,
                  passengerDetails,
                  rideDetails,
                  rideRating,
                  rideTimeline,
                  vehicleDetails,
                  // passengers
                  passengers,
                  passengerInfo,
                  ridesHistory,
                  review,
                  creditCards,
                  savedAddresses,
                  wallet,
                  // table
                  table,
                  // ststus
                  status,
                  //drivers
                  drivers,
                  editDriver,
                  viewDriver,
                  unblockDriver,
                  // contactUs
                  contactUs,
                  // chat
                  chat,
                  // sharedZones
                  addZone,
                  // settings
                  settings, profile,
                  // dispatch
                  dispatch,
                  cards,
                  // track
                  track,
                  // coupons
                  coupons,
                  // notes
                  notes,
                  // termsAndConditions
                  termsAndConditions,
                  // reports
                  ridesReports,
                  driversReports,
                  // driver customer support
                  helpCenter, ticket, messages, design,

            ] = await Promise.all([
                  // common
                  import(`./${language}/common.json`),

                  // login
                  import(`./${language}/login/login.json`),
                  import(`./${language}/login/forgotPassword.json`),
                  import(`./${language}/login/checkEmail.json`),
                  import(`./${language}/login/logout.json`),

                  // sidebar
                  import(`./${language}/sidebar.json`),
                  // topbar
                  import(`./${language}/topbar.json`),

                  // notifications
                  import(`./${language}/notifications.json`),

                  // Dashboard
                  import(`./${language}/dashboard/cardsSections.json`),
                  import(`./${language}/dashboard/statisticsSection.json`),

                  // rides
                  import(`./${language}/rides/rides.json`),
                  import(`./${language}/rides/addNewRide.json`),
                  import(`./${language}/rides/viewRide.json`),
                  import(`./${language}/rides/actions/cancelRide.json`),
                  import(`./${language}/rides/actions/cancelSharedRide.json`),
                  import(`./${language}/rides/actions/endSharedRide.json`),
                  import(`./${language}/rides/actions/endRide.json`),
                  import(`./${language}/rides/actions/assignRide.json`),
                  import(`./${language}/rides/actions/addNewCustomer.json`),
                  import(`./${language}/rides/actions/assignDriver.json`),
                  import(`./${language}/rides/details/passengerDetails.json`),
                  import(`./${language}/rides/details/rideDetails.json`),
                  import(`./${language}/rides/details/rideRating.json`),
                  import(`./${language}/rides/details/rideTimeline.json`),
                  import(`./${language}/rides/details/vehicleDetails.json`),

                  // passengers
                  import(`./${language}/passengers/passengers.json`),
                  import(`./${language}/passengers/passengerInfo.json`),
                  import(`./${language}/passengers/ridesHistory.json`),
                  import(`./${language}/passengers/review.json`),
                  import(`./${language}/passengers/creditCards.json`),
                  import(`./${language}/passengers/savedAddresses.json`),
                  import(`./${language}/passengers/wallet.json`),
                  // table
                  import(`./${language}/table.json`),

                  // ststus
                  import(`./${language}/status.json`),

                  //drivers
                  import(`./${language}/drivers/drivers.json`),
                  import(`./${language}/drivers/editDriver.json`),
                  import(`./${language}/drivers/viewDriver.json`),
                  import(`./${language}/drivers/unblockDriver.json`),

                  // contactUs
                  import(`./${language}/contactUs.json`),

                  // chat
                  import(`./${language}/chat.json`),

                  // sharedZones
                  import(`./${language}/sharedZones/addZone.json`),

                  // settings
                  import(`./${language}/settings/settings.json`),
                  import(`./${language}/settings/profile.json`),

                  // dispatch
                  import(`./${language}/dispatch/dispatcherView.json`),
                  import(`./${language}/dispatch/cards.json`),

                  // track
                  import(`./${language}/track.json`),

                  // coupons
                  import(`./${language}/coupons.json`),

                  // notes
                  import(`./${language}/notes.json`),

                  // termsAndConditions
                  import(`./${language}/termsAndConditions.json`),

                  // reports
                  import(`./${language}/reports/rides.json`),
                  import(`./${language}/reports/drivers.json`),

                  //  driver customer support
                  import(`./${language}/support/helpCenter.json`),
                  import(`./${language}/support/ticket.json`),
                  import(`./${language}/support/messages.json`),
                  import(`./${language}/design.json`),

            ]);
            return {
                  // common
                  common: common.default,
                  // login
                  login: login.default,
                  forgotPassword: forgotPassword.default,
                  checkEmail: checkEmail.default,
                  logout: logout.default,
                  // sidebar  &   topbar
                  sidebar: sidebar.default,
                  topbar: topbar.default,
                  // notifications
                  notifications: notifications.default,
                  // Dashboard
                  cardsSections: cardsSections.default,
                  statisticsSection: statisticsSection.default,
                  // rides
                  rides: rides.default,
                  addNewRide: addNewRide.default,
                  viewRide: viewRide.default,
                  cancelRide: cancelRide.default,
                  cancelSharedRide: cancelSharedRide.default,
                  endSharedRide: endSharedRide.default,
                  endRide: endRide.default,
                  assignRide: assignRide.default,
                  addNewCustomer: addNewCustomer.default,
                  assignDriver: assignDriver.default,
                  passengerDetails: passengerDetails.default,
                  rideDetails: rideDetails.default,
                  rideRating: rideRating.default,
                  rideTimeline: rideTimeline.default,
                  vehicleDetails: vehicleDetails.default,
                  // passengers
                  passengers: passengers.default,
                  passengerInfo: passengerInfo.default,
                  ridesHistory: ridesHistory.default,
                  review: review.default,
                  creditCards: creditCards.default,
                  savedAddresses: savedAddresses.default,
                  wallet: wallet.default,
                  // table
                  table: table.default,
                  // ststus
                  status: status.default,
                  //drivers
                  drivers: drivers.default,
                  editDriver: editDriver.default,
                  viewDriver: viewDriver.default,
                  unblockDriver: unblockDriver.default,
                  // contactUs
                  contactUs: contactUs.default,
                  // chat
                  chat: chat.default,
                  // sharedRide
                  addZone: addZone.default,
                  // settings
                  settings: settings.default,
                  profile: profile.default,
                  // dispatch
                  dispatch: dispatch.default,
                  cards: cards.default,
                  // track
                  track: track.default,
                  // coupons
                  coupons: coupons.default,
                  // notes
                  notes: notes.default,
                  // termsAndConditions
                  termsAndConditions: termsAndConditions.default,
                  // Reports
                  ridesReports: ridesReports.default,
                  driversReports: driversReports.default,
                  //  driver customer support
                  helpCenter: helpCenter.default,
                  ticket: ticket.default,
                  messages: messages.default,
                  design: design.default,
            };
      } catch (error) {
            console.error(
                  `Failed to load translations for language: ${language}`,
                  error
            );
            return {};
      }
};

export default loadTranslations;
